export default __webpack_public_path__ + "static/media/uk_flag.320bf846.png";